import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { films } from '@/mocks/films';
import { readHistory } from '@/utils/storage';

const stats = [
  { label: '在架影片', value: films.length, suffix: '部' },
  { label: '覆盖地区', value: 4, suffix: '个' },
  { label: '剧情条目', value: 60, suffix: '条' },
];

const introImage =
  'https://readdy.ai/api/search-image?query=Quiet%20editorial%20flat%20lay%20of%20film%20reels%20and%20stacked%20books%20on%20a%20warm%20wooden%20desk%2C%20soft%20afternoon%20light%2C%20deep%20navy%20and%20amber%20tones%2C%20minimal%20elegant%20composition&width=900&height=620&seq=home-intro-01&orientation=landscape';

export default function SiteIntro() {
  const [recentCount, setRecentCount] = useState(0);

  useEffect(() => {
    setRecentCount(readHistory().length);
  }, []);

  return (
    <section className="relative overflow-hidden rounded-lg bg-background-100 px-5 py-8 md:px-8 md:py-10">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <p className="font-label text-[11px] uppercase tracking-[0.2em] text-accent-600">About the archive</p>
          <h2 className="mt-2 font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
            一个认真写剧情介绍的地方
          </h2>
          <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-700">
            「同学的妈妈」整理电影与电视剧的基础资料、分段剧情与演职员信息，力求把一部作品讲清楚：它讲了什么、为什么值得看、适合什么样的心情。我们不做播放，只做观影前的那五分钟功课。
          </p>
          <div className="mt-6 grid grid-cols-3 gap-3 md:max-w-md">
            {stats.map((stat) => (
              <div key={stat.label} className="rounded-md bg-background-50 px-3 py-3">
                <p className="font-label text-xl font-bold text-primary-600">
                  {stat.value}
                  <span className="ml-0.5 text-[11px] font-medium text-foreground-500">{stat.suffix}</span>
                </p>
                <p className="mt-1 text-[11px] text-foreground-500">{stat.label}</p>
              </div>
            ))}
          </div>
          <div className="mt-6 flex flex-wrap items-center gap-2.5">
            <Link
              to="/about"
              className="inline-flex h-9 items-center gap-1.5 rounded-md bg-primary-500 px-4 text-xs font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer whitespace-nowrap"
            >
              了解我们
              <i className="ri-arrow-right-line w-3.5 h-3.5 flex items-center justify-center" />
            </Link>
            <Link
              to="/search"
              className="inline-flex h-9 items-center gap-1.5 rounded-md border border-background-300 bg-background-50 px-4 text-xs font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-search-line w-3.5 h-3.5 flex items-center justify-center" />
              搜索影视
            </Link>
            {recentCount > 0 && (
              <span className="font-label text-[11px] text-foreground-500">
                你有 {recentCount} 条浏览记录
              </span>
            )}
          </div>
        </div>
        <div className="lg:col-span-5">
          <div className="relative h-48 w-full overflow-hidden rounded-lg md:h-full md:min-h-[210px]">
            <img
              src={introImage}
              alt="影视资料整理场景"
              title="同学的妈妈影视大全 - 剧情介绍"
              className="h-full w-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}